import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2453106473/src/client-hcap/components/auth/sign-up-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getSession"] */ "/codebuild/output/src2453106473/src/client-hcap/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2453106473/src/client-hcap/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2453106473/src/client-hcap/node_modules/react-bootstrap/esm/Alert.js");
